module.exports = __webpack_public_path__ + "img/ATRC Platform - Cookie Policy-2.eb188976.png";